import { render, staticRenderFns } from "./LearningPageBox.vue?vue&type=template&id=632efce2&scoped=true&"
import script from "./LearningPageBox.vue?vue&type=script&lang=js&"
export * from "./LearningPageBox.vue?vue&type=script&lang=js&"
import style0 from "./LearningPageBox.vue?vue&type=style&index=0&id=632efce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632efce2",
  null
  
)

export default component.exports